export const META_TRAFFIC_PROFILE = 'r2d2m73kn8'
export const PERFORMANCE_MARKETING_TRAFFIC_PROFILE = 'ig88zpd1k7'
export const OTA_MODE_PROFILE = '23afbcc5e3'
export const BOVIO_FIRST_PROFILE = 'bov1fstqz9'

export const isMetaProfile = (profile?: string): boolean =>
  profile === META_TRAFFIC_PROFILE

export const isPerformanceProfile = (profile?: string): boolean =>
  profile === PERFORMANCE_MARKETING_TRAFFIC_PROFILE

export const isOtaModeProfile = (profile?: string): boolean =>
  profile === OTA_MODE_PROFILE

export const OFFER_MODE_COOKIE = 'offerMode'
export const OFFER_MODES = ['meta', 'otaFirst', 'otaOnly'] as const
export type OfferMode = (typeof OFFER_MODES)[number]

export const parseOfferMode = (value?: string | null): OfferMode | null =>
  OFFER_MODES.find(mode => mode === value) ?? null

/** `originId` of hotels and offers requests. Rooms send one only in `otaOnly`. */
export const OFFER_MODE_ORIGIN_ID: Record<OfferMode, string | undefined> = {
  meta: undefined,
  otaFirst: BOVIO_FIRST_PROFILE,
  otaOnly: OTA_MODE_PROFILE
}
